import React, { useContext, useState } from "react";
import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import { Bet } from "@models";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { THEME_SETTINGS } from "@theme-settings";
import { ISOToDisplayCode } from "@utils";
import { observer } from "mobx-react";

import {
	BetDetailsCashOutHistory,
	BetDetailsModalCombinations,
	BetDetailsModalDetails,
	BetDetailsModalFiscalization,
	BetDetailsModalMarkets,
	BetDetailsModalTabs,
} from ".";
import { CashOutCounter } from "../bet-details-modal-footer";
import { BetDetailsShareBetSlip } from "./share-slip-components";

export const BetDetailsModalBody = observer(
	function BetDetailsModalBody(props: { currentBet: Bet }) {
		const [activeTab, setActiveTab] = useState<string>("MARKETS");

		const store = useContext(BetDetailsModalStoreContext);

		let cashoutStore: CashoutStore;

		useEffect(() => {
			if (
				activeTab == "CASHOUT_HISTORY" &&
				props.currentBet != null &&
				!props.currentBet.isCashoutUnavailable
			) {
				cashoutStore.fetchCashoutHistoryForBetSlip(props.currentBet);
			}
		}, [props.currentBet]);

		if (store instanceof BetDetailsModalStore) {
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			cashoutStore = store.cashoutStore;
		}

		const { t } = useTranslation("mybets");

		if (!props.currentBet) {
			return null;
		}

		return (
			<>
				<BetDetailsModalTabs
					store={store}
					activeTab={activeTab}
					setActiveTab={setActiveTab}
				/>
				<div className="popup__body">
					{props.currentBet.betSlipStatus.abrv === "cashout" && (
						<div className="u-padd--bottom--xsml">
							<InfoMessageComponent
								type="success"
								size="sml"
								message={t("mybets:CASHOUT.SUCCESS_MESSAGE", {
									amount: props.currentBet.cashoutGain?.toFixed(
										2
									),

									currency: ISOToDisplayCode(
										THEME_SETTINGS.defaultCurrency
									),
								})}
							/>
						</div>
					)}
					{props.currentBet.betSlipStatus.abrv ===
						"cashout-pending" && (
						<div className="u-padd--bottom--xsml">
							<InfoMessageComponent
								type="success"
								size="sml"
								message={t(
									"mybets:CASHOUT.CASHOUT_PROCCESSING"
								)}
							/>
						</div>
					)}
					<BetDetailsModalMarkets
						isActive={activeTab === "MARKETS" ? true : false}
						store={store}
						betSlip={props.currentBet}
					/>
					<BetDetailsModalDetails
						isActive={activeTab === "BET_DETAILS" ? true : false}
						store={store}
						betSlip={props.currentBet}
					/>
					<BetDetailsModalFiscalization
						isActive={activeTab === "FISCALIZATION" ? true : false}
						store={store}
						bet={props.currentBet}
					/>
					<BetDetailsModalCombinations
						isActive={activeTab === "COMBINATIONS" ? true : false}
						store={store}
						bet={props.currentBet}
					/>
					<BetDetailsCashOutHistory
						isActive={
							activeTab === "CASHOUT_HISTORY" ? true : false
						}
						store={store}
					/>
					{cashoutStore.isCountdownVisible && <CashOutCounter />}
				</div>
				{store.isShareActive && <BetDetailsShareBetSlip />}
			</>
		);
	}
);
